import React, { useContext, useState, useEffect } from "react";
import { icons } from "../../../constants";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import AccreditationButton from "../../AccreditationButton/AccreditationButton";
import { apiRoutes } from "../../../utils/apiRoutes";
import { createData } from "../../../utils/methods";
import { useNavigate } from "react-router-dom";
import Loader from "../../Loader/Loader";
import { useAlert } from "../../../utils/AlertContext";

const ChangeStatus = ({ statusChange, onCloseClick, handleUpdateData }) => {
  const { t } = useContext(TranslationsContext);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  const handleClick = async (value) => {
    const route = apiRoutes.updatePersonStatus;

    setIsLoading(true);

    try {
      const dataToSend = {
        status: value,
        id: statusChange.id,
      };

      const response = await createData(
        route,
        dataToSend,
        showAlert,
        navigate,
        t,
      );

      if (!response) return;

      const data = response.data || response;

      // Handle partial failure
      if (data.failed && data.failed.length > 0) {
        // Partial success - some succeeded, some failed
        const successCount = data.count || 0;
        const failedCount = data.failed.length;

        // Build failure messages
        const failureMessages = data.failed.map((f) => {
          if (f.name && f.surname) {
            return `${f.name} ${f.surname} (${f.id}): ${f.reason}`;
          } else {
            return `${f.id}: ${f.reason}`;
          }
        });

        // Show warning/partial success message
        showAlert(
          `Updated ${successCount} person(s). ${failedCount} failed:\n${failureMessages.join("\n")}`,
          "warning",
        );

        // Only update local state if at least one succeeded
        if (successCount > 0) {
          handleUpdateData({ status: value, id: statusChange.id });
        }
        return;
      }

      // Full success
      const successCount = data.count || 1;
      console.log("Podaci su uspešno sačuvani:", data);
      handleUpdateData({ status: value, id: statusChange.id });
      showAlert(`Successfully updated ${successCount} person(s)`, "success");
      onCloseClick();
    } catch (error) {
      console.error("API poziv nije uspeo:", error.message);
      if (error?.code === "UNAUTHORIZED") {
        navigate("/login");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Handle Enter key to trigger accept action (if not already accepted)
    const handleEnterKey = (event) => {
      if (
        event.key === "Enter" &&
        !event.shiftKey &&
        !event.ctrlKey &&
        !event.metaKey
      ) {
        // Don't trigger if user is typing in a textarea or input
        const target = event.target;
        if (
          target.tagName === "TEXTAREA" ||
          (target.tagName === "INPUT" && target.type !== "submit")
        ) {
          return;
        }
        event.preventDefault();
        if (statusChange?.status !== "odobren") {
          handleClick("odobren");
        }
      }
    };

    document.addEventListener("keydown", handleEnterKey);

    return () => {
      document.removeEventListener("keydown", handleEnterKey);
    };
  }, [statusChange]);

  if (isLoading) return <Loader />;

  console.log("statusChange", statusChange);

  return (
    <div
      className="flex-direction-column gap-24 justify-between status-modal"
      style={{
        borderTop: `10px solid ${
          statusChange?.status === "odobren"
            ? "var(--Green-box)"
            : statusChange?.status === "odbijen"
              ? "var(--Red-box)"
              : "var(--Yellow-box)"
        }`,
      }}
    >
      <div className="flex-direction-row justify-between width-100">
        <p className="inria-sans-400 font-16 modal-title">
          {t("STATUS_CHANGE")}
        </p>
        <img
          className="pointer"
          src={icons.close_gray}
          onClick={onCloseClick}
          alt="X"
        />
      </div>
      <div className="flex-direction-column gap-48 items-center">
        <p
          className="inria-sans-400 font-20"
          style={{ color: "var(--text-black)" }}
        >
          {statusChange?.fullName}
        </p>
        <div className="flex-direction-row gap-24 width-100 person-card-buttons">
          <AccreditationButton
            onClick={() => handleClick("odbijen")}
            type="decline"
            title={t("REJECT")}
            icon={icons.decline}
            className="person-card-btn"
            disabled={statusChange?.status === "odbijen"}
          />
          <AccreditationButton
            onClick={() => handleClick("odobren")}
            type="accept"
            title={t("ACCEPT")}
            icon={icons.accept}
            className="person-card-btn"
            disabled={statusChange?.status === "odobren"}
          />
        </div>
      </div>
    </div>
  );
};
export default ChangeStatus;
